import { render, staticRenderFns } from "./DictList.vue?vue&type=template&id=11e1304a&scoped=true&"
import script from "./DictList.vue?vue&type=script&lang=ts&"
export * from "./DictList.vue?vue&type=script&lang=ts&"
import style0 from "./DictList.vue?vue&type=style&index=0&id=11e1304a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e1304a",
  null
  
)

export default component.exports